import { useRef, useEffect, useState } from "react";
import useRegistrationContext from "../../../../hooks/useRegistrationContext";
import {
	getRegions,
	getConstituencies,
	getBranches,
	getPresidents,
} from "../../../../api/apiServices";
import toast, { Toaster } from "react-hot-toast";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";

const RegionConstituency = () => {
	useEffect(() => {
		// 👇️ scroll to top on page load
		window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
	}, []);
	const outsideRegions = ["US", "UK", "CH", "GM", "NA"];
	const inputRef = useRef();

	const [regions, setRegions] = useState([]);
	const [regional_presidents, setRegionalPresidents] = useState([]);
	const [constituencies, setConstituencies] = useState([]);
	const [branches, setBranches] = useState([]);
	const [regionConstituencies, setRegionConstituencies] = useState([]);
	const [constituencyBranches, setConstituencyBranches] = useState([]);

	const { data, handleChange, setData } = useRegistrationContext();

	useEffect(() => {
		getRegions().then((res) => setRegions(res));
		getBranches().then((res) => setBranches(res));
		getConstituencies().then((res) => setConstituencies(res));
		getPresidents().then((res) => setRegionalPresidents(res));
	}, []);

	const handleRegion = (e) => {
		const name = e.target.name;
		const value = e.target.value;
		const region_name = regions?.find(
			(region) => region.region_code === value
		);
		let region_constituencies = null
		let president = null;
		if (!outsideRegions.includes(value)) {
			region_constituencies = constituencies?.filter((constituency) =>
				constituency.region_code.includes(value)
			);
			president = regional_presidents?.find(
				(president) => president.region_code === value
			);	
		}

		if (outsideRegions.includes(value)) {
			setData((prevData) => ({
				...prevData,
				[name]: value,
				regionsRegionName: region_name.region,
				regionsRegionalPresident: "RICHARD ANAMOO",
				regionsRegionalPresidentMobileNumber: "233548433365",
				regionsRegionalPresidentEmail: "raynamoo@gmail.com",
				regionsConstituencyCode: value,
				regionsConstituencyName: region_name.region,
				isOutsideGhana: true,
			}));
		} else {
			setData((prevData) => ({
				...prevData,
				[name]: value,
				regionsRegionName: region_name.region,
				regionsRegionalPresident: president.fullname,
				regionsRegionalPresidentMobileNumber: president.mobile_number,
				regionsRegionalPresidentEmail: president.email,
				isOutsideGhana: false,
			}));
			setRegionConstituencies(region_constituencies);
		}

	};

	const handleConstituency = (e) => {
		const name = e.target.name;
		const value = e.target.value;
		const constituency = regionConstituencies?.find(
			(constituency) => constituency.constituency_code === value
		);
		const constituencyBranches = branches?.filter((branch) =>
			branch.constituency_code.includes(value)
		);		
		if (constituencyBranches.length > 0) {
			setConstituencyBranches(constituencyBranches)
		}
		setData((prevData) => ({
            ...prevData,
			[name]: value,
			regionsConstituencyName: constituency.constituency,
           
        }));
	};

	const handleBranch = (e) => {
		const name = e.target.name;
		const value = e.target.value;
		const branchName = constituencyBranches?.find(
			(branch) => branch.branch_code === value
		);
		setData((prevData) => ({
            ...prevData,
			[name]: value,
			regionsBranchName: branchName.branch,

        }));
	};

	const content = (
		<>
			<fieldset className="col-sm-6">
			<legend>Region/Constituency/Branch Information</legend>
				<div className="form-group row">
					<label
						htmlFor="region_code"
						className="col-sm-4 label-text"
					>
						Region<span>&nbsp;&nbsp;*</span>
					</label>
					<div className="col-sm-8">
						<select
							type="text"
							id="region_code"
							autoComplete="off"
							style={{
								textTransform: "uppercase",
							}}
							onChange={handleRegion}
							value={data.regionsRegionCode}
							required
							name="regionsRegionCode"
							className="form-control"
						>
							<option value=""></option>
							{regions?.map((reg, index) => (
								<option value={reg.region_code} key={index}>
									{reg.region} - {reg.region_code}
								</option>
							))}
						</select>
					</div>
				</div>
				{!data.isOutsideGhana ?					
				<div className="form-group row">
					<label
						htmlFor="constituency_code"
						className="col-sm-4 label-text"
					>
						Constituency<span>&nbsp;&nbsp;*</span>
					</label>
					<div className="col-sm-8">
						<select
							type="text"
							id="constituency_code"
							autoComplete="off"
							style={{
								textTransform: "uppercase",
							}}
							onChange={handleConstituency}
							value={data.regionsConstituencyCode}
							required
							name="regionsConstituencyCode"
							className="form-control"
						>
							<option value=""></option>
							{regionConstituencies?.map((consti, index) => (
								<option
									value={consti.constituency_code}
									key={index}
								>
									{consti.constituency} -{" "}
									{consti.constituency_code}
								</option>
							))}
						</select>
					</div>
				</div>
					:
					<div className="form-group row">
					<label
						htmlFor="constituency_code"
						className="col-sm-4 label-text"
					>
						Constituency<span>&nbsp;&nbsp;*</span>
					</label>
					<div className="col-sm-8">
						<input
							type="text"
							id="constituency_code"
							autoComplete="off"
							style={{
								textTransform: "uppercase",
							}}
							onChange={handleConstituency}
							value={data.regionsConstituencyName}
							required
							name="regionsConstituencyCode"
							className="form-control"
						/>
							
					</div>
				</div>
				}
		
				{!data.isOutsideGhana && data.isNdcMember && (
					<div className="form-group row">
						<label htmlFor="branch" className="col-sm-4 label-text">
							Branch<span>&nbsp;&nbsp;*</span>
						</label>
						<div className="col-sm-8">
							<select
								type="text"
								id="branch"
								autoComplete="off"
								style={{
									textTransform: "uppercase",
								}}
								onChange={handleBranch}
								value={data.regionsBranchCode}
								required
								name="regionsBranchCode"
								className="form-control"
							>
								<option value=""></option>
								{constituencyBranches?.map((branch, index) => (
									<option
										value={branch.branch_code}
										key={index}
									>
										{branch.branch} - {branch.branch_code}
									</option>
								))}
							</select>
						</div>
					</div>
				)}
				<div className="form-group row">
					<label
						htmlFor="recommended_by"
						className="col-sm-4 label-text"
					>
						Recommended By<span>&nbsp;&nbsp;*</span>
					</label>
					<div className="col-sm-8">
						<input
							ref={inputRef}
							type="text"
							id="recommended_by"
							autoComplete="off"
							onChange={handleChange}
							required
							style={{
								textTransform: "uppercase",
							}}
							value={data.regionsRecommendedBy}
							name="regionsRecommendedBy"
							className="form-control"
						/>
					</div>
				</div>
			</fieldset>
			<fieldset className="col-sm-6">
				<legend>Regional President Information</legend>
				<div className="form-group row">
					<label
						htmlFor="regional_president"
						className="col-sm-4 label-text"
					>
						Regional President<span>&nbsp;&nbsp;*</span>
					</label>
					<div className="col-sm-8">
						<input
							ref={inputRef}
							type="text"
							id="regional_president"
							autoComplete="off"
							onChange={handleChange}
							required
							disabled
							style={{
								textTransform: "uppercase",
							}}
							value={data.regionsRegionalPresident}
							name="regionsRegionalPresident"
							className="form-control"
						/>
					</div>
				</div>
				<div className="form-group row">
					<label
						htmlFor="president_mobile_number"
						className="col-sm-4 label-text"
					>
						Mobile Number<span>&nbsp;&nbsp;*</span>
					</label>
					<div className="col-sm-8">
						<PhoneInput
							type="tel"
							id="president_mobile_number"
							inputStyle={{
								paddingTop: 16,
								paddingRight: 14,
								paddingBottom: 15,
								paddingLeft: 58,
								fontSize: 16,
								width: "100%",
								zIndex: 1,
								height: 40,
								backgroundColor: "#F3F6F9",
							}}
							countryCodeEditable={false}
							country={data.country}
							enableSearch={true}
							value={data.regionsRegionalPresidentMobileNumber}
							inputProps={{
								name: "regionsRegionalPresidentMobileNumber",
								required: true,
								autoFocus: true,
							}}
							disabled
						/>
					</div>
				</div>
				<div className="form-group row">
					<label
						htmlFor="president_email"
						className="col-sm-4 label-text"
					>
						Email Address<span>&nbsp;&nbsp;*</span>
					</label>
					<div className="col-sm-8">
						<input
							type="email"
							id="president_email"
							autoComplete="off"
							onChange={handleChange}
							style={{
								textTransform: "lowercase",
							}}
							required
							disabled
							value={data.regionsRegionalPresidentEmail}
							name="regionsRegionalPresidentEmail"
							className="form-control"
						/>
					</div>
				</div>
			</fieldset>
		</>
	);
	<Toaster toastOptions={{ position: "top-center" }} />;
	return content;
};
export default RegionConstituency;
